import PromptBuilderEmptyStateIcon from '@/assets/icons/PromptBuilderEmptyStateIcon';
import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

export const BuilderEmptyStateView = ({
  message = 'No Data Found',
  minHeight = 200,
  iconWidth,
  iconHeight,
  content
}: BuilderEmptyStateViewProps) => {
  const hasCustomContent = content !== undefined;

  return (
    <Box display='flex' flexDirection='column' alignItems='center' minHeight={minHeight}>
      <PromptBuilderEmptyStateIcon width={iconWidth} height={iconHeight} />
      {hasCustomContent ? (
        content
      ) : (
        <Typography
          width={260}
          fontSize='12px'
          fontWeight={400}
          color='secondary'
          mx='auto'
          lineHeight={1.5}
          sx={{ textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

type BuilderEmptyStateViewProps = {
  message?: ReactNode;
  minHeight?: number;
  iconWidth?: number;
  iconHeight?: number;
  content?: ReactNode;
};
